export const altLOGO = "NeuralDrive Logo"
export const altVisSystem = "Anwendung visuelles System Padulla Transformation Cube"
export const altKogni = "Anwendung Kognitionsspiele und NeuralTools, Pfeilgenerator und Slash"
export const altMain = "NeuralDrive App für neurozentriertes Training"